import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { HotelReservationForm } from '@/pages/hotel/form';
import { ScrollPageContainer } from '@repo/ui/components/molecules/scroll-page-container';
import { PageHeader } from '@repo/ui/components/molecules/page-header';
import { useHotelAccess } from '@/lib/hooks/use-hotel-access';
import { RoleGuard } from '@/components/molecules/role-guard';

export const Route = createFileRoute('/protected/_layout/hotel/_layout/new')({
  component: NewHotelReservationRoute,
});

function NewHotelReservationRoute() {
  const { t } = useTranslation();
  const { canWriteHotel, isLoading } = useHotelAccess();
  return (
    <RoleGuard hasAccess={canWriteHotel} isLoading={isLoading}>
      <ScrollPageContainer className="gap-5">
        <PageHeader title={t('hotel.new')} />
        <div className="max-w-3xl">
          <HotelReservationForm />
        </div>
      </ScrollPageContainer>
    </RoleGuard>
  );
}
